export default `<p>Defi借貸池採用動態分級年化收益率（APY）機制。為最大限度提高資金效率，該合約引入了「每日區間上限結算」機制，當前收益按當前規則計算。系統將自動匹配您持有層級對應的最高收益。</p>

<h2>一、收益機制說明</h2>
<p>當您完成錢包授權並由平台按約定轉入借款本金後，系統會生成對應的借款記錄。每個自然日，平台依據以下規則計算該記錄的收益：</p>
<ul>
  <li><strong>借款本金：</strong>該筆已轉入並記錄的 USDT 金額；</li>
  <li><strong>檔位利率：</strong>根據該筆本金所在區間匹配日化收益率，區間按最大值結算；</li>
  <li><strong>日收益：</strong>借款本金 × 實際日化收益率 ÷ 100；</li>
  <li><strong>最新配置：</strong>後台調整檔位後，當前利息按最新生效規則重新計算。</li>
</ul>
<p>平台收益提現僅影響賬戶可提現餘額及複利累計基數，<strong>不影響鏈上錢包餘額</strong>。收益按<strong>每日一次完整日化利率</strong>計算，後台配置的多個時點僅用於當日收益更新與展示，不會重複計算日化收益。收益累計計入賬戶，可在「資產 → 結算訂單」中查看明細。歷史收益不代表未來表現。</p>

<h2>二、收益階梯表</h2>
<p>下表展示 <strong>Defi Lending Pool</strong> 當前生效的借款本金檔位與對應日化收益率。單筆借出本金越高，可匹配的檔位利率越高。表中利率均為<strong>日化百分比</strong>，非年化 APY。</p>
<!-- YIELD_TIER_TABLE -->
<p><strong>說明：</strong>每筆借款按該筆<strong>借出本金</strong>獨立匹配唯一檔位。同一用戶有多筆借款時分別計算，再匯總展示本金、利息和本息合計。</p>

<h2>三、檔位匹配規則</h2>
<ul>
  <li>完成鏈上授權並實際轉入後生成的借款記錄參與計息；</li>
  <li>低於 100 USDT 仍可借出，但實際日化利率為 0%；</li>
  <li>每個檔位對應一個 USDT 本金區間，每筆借款自動匹配唯一適用檔位；</li>
  <li>若某檔位配置為區間利率，則統一按該區間的<strong>最大日化利率</strong>結算；</li>
  <li>檔位配置可由平台運營方調整，變更僅對後續結算生效，不影響歷史訂單。</li>
</ul>

<h2>四、結算與展示</h2>
<h3>4.1 結算週期</h3>
<ul>
  <li><strong>計息頻率：</strong>每個已授權資產每日按完整日化利率計息一次，多個展示時點不會重複計息；</li>
  <li><strong>首次結算：</strong>當日完成授權的錢包，從次日起開始計息結算；</li>
  <li><strong>訂單欄位：</strong>結算金額、幣種（USDT / USDC）、適用利率、結算時間。</li>
</ul>
<h3>4.2 資產頁指標</h3>
<p>在「資產」頁可查看<strong>累計收益</strong>（歷史結算總和）與<strong>今日收益</strong>（當日已結算部分），數據以系統訂單記錄為準。</p>

<h2>五、如何在 Defi Lending Pool 開始獲取收益</h2>
<ol>
  <li>登入賬戶並連接兼容的 Web3 錢包；</li>
  <li>在錢包中確認 USDT 的 <strong>Approve（授權）</strong> 交易；</li>
  <li>平台按雙方約定轉入本金後，系統生成借款記錄；</li>
  <li>每筆本金自動匹配收益檔位，區間按上限計算；</li>
  <li>在「資產」頁查看在借本金、當前利息與本息合計。</li>
</ol>

<h2>六、風險提示</h2>
<p><strong>Defi Lending Pool</strong> 採用非託管模式，平台不保管用戶私鑰。鏈上授權存在智能合約及市場風險，檔位利率、池容量與結算結果可能發生變化。參與前請仔細閱讀「規則與安全」頁面。</p>

<p>— 檔位利率數據同步自平台後端配置，頁面展示僅供參考；最終結算金額以每日訂單記錄為準。</p>`
